import { Link } from 'bcms-react';
import { TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableItemView } from 'components/shared/views/TableView';
import React from 'react';
import './styles.css';

/**
 * @function StatementTable
 * @param {React.Component} children - Allows us to inject other components/content.
 * @returns {React.Component}
 * @example
 * <StatementTable>
 *    <StatementView />
 * </StatementTable>
 */

export default function StatementTable(props) {
  return (
    <table className="statements-table">
      <TableColumnContainer className="text-left">
          <TableColumnView text="Date" icon="SortIcon"></TableColumnView>
          <TableColumnView text="Account Nickname" icon="SortIcon"></TableColumnView>
          <TableColumnView text="Account Number" icon="SortIcon"></TableColumnView>
          <TableColumnView text="Document Type Name" icon="SortIcon"></TableColumnView>
          <TableColumnView text="Category" icon="SortIcon"></TableColumnView>
      </TableColumnContainer>
      <TableBody>
        {props.children}
      </TableBody>
    </table>
  )
}

/**
 * @function StatementView
 * @param {React.Component} link - Allows us to inject a Link component.
 * @param {String} accountNickname - String to show the Account Nickname.
 * @param {String} accountNumber - String to show the Account Last Four Numbers.
 * @param {String} documentName - String to show the document name.
 * @param {String} documentType - String to show the document type.
 * @param {String} id - The id of the document for creating data-points
 * @returns {React.Component}
 * @example
 * <StatementTable>
 *    <StatementView link={<Link to="/">Link Text</Link>} accountNickname="Checking Account" accountNumber="x1234" documentName="Doc-Name" documentType="pdf" />
 * </StatementTable>
 */

export function StatementView(props) {
  const link = props.link ?? (<Link to="/">[Link]</Link>);
  const documentName = props.documentName ?? "[Document Name]";
  const documentType = props.documentType ?? "[Document Type]";
  const accountNickname = props.accountNickname ?? "[Account Nickname]";
  const accountNumber = props.accountNumber ?? "[x1234]";
  const id = props.id ?? "";

return (
  <TableItemContainer>
      <TableItemView data-point={ `Statement_Item_${ id }` } >{link}</TableItemView>
      <TableItemTextView text={accountNickname} />
      <TableItemTextView text={accountNumber} />
      <TableItemTextView text={documentName} />
      <TableItemTextView text={documentType} />
  </TableItemContainer>
);
}